<ng-container>
  <div class="menuButton" [matMenuTriggerFor]="beforeMenu" (menuOpened)="menuOpened()" (menuClosed)="menuClosed()"><fa-icon [icon]="menuIcon" class="faMenuIcon"></fa-icon></div>
  <mat-menu #beforeMenu="matMenu" xPosition="before">
    <button mat-menu-item class="menuItem" #menuItems [class.hide]="item.isHidden" (click)="itemClick(item, i)" *ngFor="let item of menuList; let i = index;">{{ item.label }}</button>
  </mat-menu>    
</ng-container>
